import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.15 2.31H4.9a3 3 0 0 0-.85.11v-1.2c-1.73 0-2.88.54-2.88 2.14V10.06a3.75 3.75 0 0 0 3.73 3.75h6.25a3.76 3.76 0 0 0 3.75-3.75v-4a3.76 3.76 0 0 0-3.75-3.75Zm2.25 7.75a2.25 2.25 0 0 1-2.25 2.25H4.9a2.25 2.25 0 0 1-2.25-2.25V9.8A1.05 1.05 0 0 1 3.76 9h.29V4a2.19 2.19 0 0 1 .85-.17h6.25a2.25 2.25 0 0 1 2.25 2.23Zm-2.4.69H6.8a.75.75 0 0 1 0-1.5h3.41V6.46a.75.75 0 0 1 1.5 0V10a.76.76 0 0 1-.71.75ZM6.8 8.42a.76.76 0 0 1-.75-.75V6.46a.76.76 0 0 1 .75-.75h1.47a.75.75 0 0 1 0 1.5h-.72v.46a.75.75 0 0 1-.75.75ZM2.65 2.29';
const draw24px =
  'M18.17,4.55H5.85v-2c-2.26,0-4,.82-4,3.25V17.47A3.75,3.75,0,0,0,5.6,21.22H18.17a3.75,3.75,0,0,0,3.75-3.75V8.3A3.75,3.75,0,0,0,18.17,4.55Zm2.25,12.92a2.25,2.25,0,0,1-2.25,2.25H5.6a2.25,2.25,0,0,1-2.25-2.25v-.21A1.65,1.65,0,0,1,5.1,15.51h.75V6.05H18.17A2.25,2.25,0,0,1,20.42,8.3Zm-4-.9H9.51a.75.75,0,1,1,0-1.5h6.16V10.36a.75.75,0,0,1,1.5,0v5.46A.75.75,0,0,1,16.42,16.57Zm-6.65-3.3A.76.76,0,0,1,9,12.52V10.36a.76.76,0,0,1,.75-.75H12.5a.75.75,0,0,1,0,1.5h-2v1.41A.75.75,0,0,1,9.77,13.27Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SheetsIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'sheets'),
) as IconWithRender;

SheetsIcon.displayName = 'SheetsIcon';
SheetsIcon.propTypes = Icon.propTypes;
SheetsIcon.renderIcon = (props) => <SheetsIcon {...props} />;
export default SheetsIcon;
